<template>
  <div class="notification is-info is-light" v-if="isActive">
    <button class="delete" @click="clickDeleteButton()"></button>
    <p>
      {{ $t("announce.message1") }}<br />
      {{ $t("announce.message2") }}
    </p>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import imsrAnnounce from "@/imsrAnnounce.js";
import Cookies from "js-cookie";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const isActive = ref(false);
    const announceCheckDateCookies = ref("");
    const { t } = useI18n();

    const COOKIE_EXPIRES_DAYS = 14;
    const ANNOUNCE_COOKIE_NAME = "announceCheckDate";

    const clickDeleteButton = () => {
      const now = new Date();
      isActive.value = false;
      Cookies.set(ANNOUNCE_COOKIE_NAME, now, { expires: COOKIE_EXPIRES_DAYS });
    };

    onMounted(() => {
      try {
        const now = new Date();
        const announceDate = new Date(imsrAnnounce.maintenanceDate);

        // 不正な日付をチェック
        if (isNaN(announceDate.getTime())) {
          console.warn("Invalid maintenance date");
          return;
        }

        announceCheckDateCookies.value = Cookies.get(ANNOUNCE_COOKIE_NAME);

        if (!announceCheckDateCookies.value && now <= announceDate) {
          isActive.value = true;
        }
      } catch (error) {
        console.error("Error initializing announce:", error);
      }
    });

    return {
      isActive,
      imsrAnnounce,
      clickDeleteButton,
      t
    };
  }
};
</script>
